<marv-select 
    [class.hide]="this.hide"
    [label]="this.labelSelect" 
    [icon]="this.iconSelect" 
    [formName]="this.formName" 
    [items]="this.items" 
    [multiple]="this.multiple"
    [displayItemsSelected]="this.displayItemsSelected"
    [errorText]="this.errorText"
    [withSpeechToText]="this.withSpeechToText"
></marv-select>